import { defineStore } from "pinia";
import { fetchWrapper } from "../_helpers/fetch-wrapper";
import { useAuthStore } from "./auth.store";

export const useBettorStore = defineStore({
  id: "bettor",
  state: () => ({
    isLoading: false,
    isGetCheckSummaryLoading: false,
    isGetAllLoading: false,
    isGetMatchesLoading: false,
    isPotentialLoading: false,
    isConfirmedLoading: false,
    isResolvedLoading: false,
    isArchiveLoading: false,
    isMatchesInGroupLoading: false,
    applicationStatus: false,
    appStatusCause: "",
    items: [],
    totalItems: [],
    allMatches: [],
    potentialMatches: [],
    potentialMatchesUngrouped: [],
    completedMatches: [],
    completedMatchesUngrouped: [],
    resolvedMatches: [],
    resolvedMatchesUngrouped: [],
    archiveMatches: [],
    archiveMatchesUngrouped: [],
    allCheckSummary: [],
    totalSummaryMatches: 0,
    totalMatches: 0,
    totalPotentialMatches: 0,
    totalConfirmedMatches: 0,
    totalResolvedMatches: 0,
    totalArchiveMatches: 0,
    totalMatchesInGroup: 0,
    item: {},
    matchesInGroupItems: [],
    jurisdiction: [],
    leagues: [],
    contactInfo: {},
    responseStatus: 100,
    notifications: {},
    dateRequested: '',
    matchesChecks: true,
    getAllCheckSummary: {
      page: 1,
      rowsPerPage: 25,
      sortBy: "date_requested",
      sortType: "desc",
      timezone: "Eastern"
    },
    getAllCheckHistory: {
      page: 1,
      rowsPerPage: 25,
      sortBy: "when_request_completed",
      sortType: "desc",
      timezone: "Eastern"
    },
    getMatchesUuid: {
      uuid: '',
      page: 1,
      rowsPerPage: 25,
      search: "",
      sortBy: "when_match",
      sortType: "desc",
    },
    getPotentialPagePagination: {
      page: 1,
      rowsPerPage: 25,
      search: "",
      sortBy: "when_match",
      sortType: "desc",
    },
    getConfirmedPagePagination: {
      page: 1,
      rowsPerPage: 25,
      search: "",
      sortBy: "when_match",
      sortType: "desc",
    },
    getResolvedPagePagination: {
      page: 1,
      rowsPerPage: 25,
      search: "",
      sortBy: "when_match",
      sortType: "desc",
    },
    getArchivedPagePagination: {
      page: 1,
      rowsPerPage: 25,
      search: "",
      sortBy: "when_match",
      sortType: "desc",
    },
    getMatchesInGroupPagePagination: {
      page: 1,
      rowsPerPage: 25,
      search: "",
      sortBy: "when_match",
      sortType: "desc",
    },
  }),
  actions: {

    setDateRequested(date) {
      this.dateRequested = date;
    },
    async resetTimeZoneAndCheckHistory(){
      this.matchesChecks = true;
      this.getAllCheckSummary = {
        page: 1,
        rowsPerPage: 25,
        sortBy: "date_requested",
        sortType: "desc",
        timezone: "Eastern"
      };
      this.getAllCheckHistory = {
        page: 1,
        rowsPerPage: 25,
        sortBy: "when_request_completed",
        sortType: "desc", 
        timezone: "Eastern"
      };
    },
    async resetSpecificObject() {

      this.getMatchesUuid = {
        uuid: '',
        page: 1,
        rowsPerPage: 25,
        search: "",
        sortBy: "when_match",
        sortType: "desc",
      };
      this.getPotentialPagePagination = {
        page: 1,
        rowsPerPage: 25,
        search: "",
        sortBy: "when_match",
        sortType: "desc",
      };
      this.getConfirmedPagePagination = {
        page: 1,
        rowsPerPage: 25,
        search: "",
        sortBy: "when_match",
        sortType: "desc",
      };
      this.getResolvedPagePagination = {
        page: 1,
        rowsPerPage: 25,
        search: "",
        sortBy: "when_match",
        sortType: "desc",
      };
      this.getArchivedPagePagination = {
        page: 1,
        rowsPerPage: 25,
        search: "",
        sortBy: "when_match",
        sortType: "desc",
      };
      this.getMatchesInGroupPagePagination = {
        page: 1,
        rowsPerPage: 25,
        search: "",
        sortBy: "when_match",
        sortType: "desc",
      };
    },
    async updateUserRoleManually(newRole) {
      await fetchWrapper.post("update-user-role", { user_role: newRole }).then((res) => {
        if(res){
          const authStore = useAuthStore();
          authStore.updateRoleInStore(newRole);
        }
      });
    },
    async updateUserTimeZone(timeZone) {
      await fetchWrapper.post("update-timezone", { timezone: timeZone }).then((res) => {
        if(res){
          const authStore = useAuthStore();
          authStore.updateTimeZone(timeZone);
        }
      });
    },
    async getAll(date_requested) {
      this.isGetAllLoading = true;
      const { page, rowsPerPage, sortBy, sortType , timezone } = this.getAllCheckHistory;
      const matches_only = this.matchesChecks;
      const response = await fetchWrapper.get(
        `get-checks?date_requested=${date_requested}&page=${page}&limit=${rowsPerPage}&sort_by=${sortBy}&order_by=${sortType}&timezone=${timezone}&matches_only=${matches_only}`
      );

      if (response) {
        this.items = response.get_checks.map((check) => {
          const metadata = check.metadata ? JSON.parse(check.metadata.replace(/'/g, '"')) : {};
          if (metadata.source_type) {
            // Extract source_type value and all
            // const { source_type, 'User ID': userId, ...rest } = metadata;
             // Extract source_type value
            const { source_type } = metadata;
            // Merge source_type value with other values except UserID
            // const mergedValue = Object.values(rest).filter((value, key) => key !== 'User ID').join(': ');
            // Format metadata based on conditions
            // const formattedMetadata = mergedValue ? `${source_type}: ${mergedValue}` : source_type;
            // console.log(formattedMetadata , "forma");
            return {
              ...check,
              metadata: source_type,
            };
          } else {
            // If source_type is not present, handle as usual
            return {
              ...check,
              metadata,
            };
          }
        });
        this.totalItems = response.total_records;
      }

      this.isGetAllLoading = false;
    },
    setMatchesChecks(value) {
      this.matchesChecks = value;
    },
    async getCheckSummary() {
      this.isGetCheckSummaryLoading = true;
      const { page, rowsPerPage, sortBy, sortType , timezone } = this.getAllCheckSummary;
      const response = await fetchWrapper.get(
        `check-summary?page=${page}&limit=${rowsPerPage}&sort_by=${sortBy}&order_by=${sortType}&timezone=${timezone}`
      );
      if (response) {
        this.allCheckSummary = response.get_check_summary;
        this.totalSummaryMatches = response.total_records;
      }

      this.isGetCheckSummaryLoading = false;
    },
    async getMatches(uuid) {
      this.isGetMatchesLoading = true;
      this.getMatchesUuid.uuid = uuid; // Update uuid in the state
      await fetchWrapper
        .get(
          `v2/get-matches?uuid=${uuid}&page=${this.getMatchesUuid.page}&limit=${this.getMatchesUuid.rowsPerPage}&search=${this.getMatchesUuid.search}&sort_by=${this.getMatchesUuid.sortBy}&order_by=${this.getMatchesUuid.sortType}`
        )
        .then((res) => {
          this.allMatches = res.match_records;
          this.totalMatches = res.total_records;
        });
      this.isGetMatchesLoading = false;
    },
  async getPotentialIncidents() {
    this.isPotentialLoading = true;
    await fetchWrapper
      .get(
        "v2/get-unresolved-matches?unresolved_status=U&page=" +
          this.getPotentialPagePagination.page +
          "&limit=" +
          this.getPotentialPagePagination.rowsPerPage +
          "&search=" +
          this.getPotentialPagePagination.search +
          "&sort_by=" +
          this.getPotentialPagePagination.sortBy +
          "&order_by=" +
          this.getPotentialPagePagination.sortType
      )
      .then((res) => {
        if (res) {
          this.potentialMatches = organizeRecords(
            res.result_unresolved_matches
          );
          this.totalPotentialMatches = res.total_records;
        }
      });
    this.isPotentialLoading = false;
  },
  async getPotentialIncidentsUngrouped() {
    this.isPotentialLoading = true;
    await fetchWrapper
      .get(
        "v2/get-unresolved-matches-ungrouped?unresolved_status=U&page=" +
          this.getPotentialPagePagination.page +
          "&limit=" +
          this.getPotentialPagePagination.rowsPerPage +
          "&search=" +
          this.getPotentialPagePagination.search +
          "&sort_by=" +
          this.getPotentialPagePagination.sortBy +
          "&order_by=" +
          this.getPotentialPagePagination.sortType
      )
      .then((res) => {
        if (res) {
          this.potentialMatchesUngrouped = organizeRecordsUngrouped(
            res.result_unresolved_matches
          );
          this.totalPotentialMatches = res.total_records;
        }
      });
    this.isPotentialLoading = false;
  },
async getCompletedIncidents() {
  this.isConfirmedLoading = true;
  await fetchWrapper
    .get(
      "v2/get-unresolved-matches?unresolved_status=C&page=" +
        this.getConfirmedPagePagination.page +
        "&limit=" +
        this.getConfirmedPagePagination.rowsPerPage +
        "&search=" +
        this.getConfirmedPagePagination.search +
        "&sort_by=" +
        this.getConfirmedPagePagination.sortBy +
        "&order_by=" +
        this.getConfirmedPagePagination.sortType
    )
    .then((res) => {
      if (res) {
        this.completedMatches = organizeRecords(
          res.result_unresolved_matches
        );
        this.totalConfirmedMatches = res.total_records;
      }
    });
  this.isConfirmedLoading = false;
},
async getCompletedIncidentsUngrouped() {
  this.isConfirmedLoading = true;
  await fetchWrapper
    .get(
      "v2/get-unresolved-matches-ungrouped?unresolved_status=C&page=" +
        this.getConfirmedPagePagination.page +
        "&limit=" +
        this.getConfirmedPagePagination.rowsPerPage +
        "&search=" +
        this.getConfirmedPagePagination.search +
        "&sort_by=" +
        this.getConfirmedPagePagination.sortBy +
        "&order_by=" +
        this.getConfirmedPagePagination.sortType
    )
    .then((res) => {
      if (res) {
        this.completedMatchesUngrouped = organizeRecordsUngrouped(
          res.result_unresolved_matches
        );
        this.totalConfirmedMatches = res.total_records;
      }
    });
  this.isConfirmedLoading = false;
},

async getResolvedIncidents() {
  this.isResolvedLoading = true;
  await fetchWrapper
    .get(
      "v2/get-resolved-matches?page=" +
        this.getResolvedPagePagination.page +
        "&limit=" +
        this.getResolvedPagePagination.rowsPerPage +
        "&search=" +
        this.getResolvedPagePagination.search +
        "&sort_by=" +
        this.getResolvedPagePagination.sortBy +
        "&order_by=" +
        this.getResolvedPagePagination.sortType
    )
    .then((res) => {
      if (res) {
        this.resolvedMatches = organizeRecords(res.result_resolved_matches);
        this.totalResolvedMatches = res.total_records;
      }
    });
  this.isResolvedLoading = false;
},
async getResolvedIncidentsUngrouped() {
  this.isResolvedLoading = true;
  await fetchWrapper
    .get(
      "v2/get-resolved-matches-ungrouped?page=" +
        this.getResolvedPagePagination.page +
        "&limit=" +
        this.getResolvedPagePagination.rowsPerPage +
        "&search=" +
        this.getResolvedPagePagination.search +
        "&sort_by=" +
        this.getResolvedPagePagination.sortBy +
        "&order_by=" +
        this.getResolvedPagePagination.sortType
    )
    .then((res) => {
      if (res) {
        this.resolvedMatchesUngrouped = organizeRecordsUngrouped(res.result_resolved_matches);
        this.totalResolvedMatches = res.total_records;
      }
    });
  this.isResolvedLoading = false;
},
async getArchiveIncidents() {
  this.isArchiveLoading = true;
  await fetchWrapper
    .get(
      "v2/get-no-match-matches?page=" +
        this.getArchivedPagePagination.page +
        "&limit=" +
        this.getArchivedPagePagination.rowsPerPage +
        "&search=" +
        this.getArchivedPagePagination.search +
        "&sort_by=" +
        this.getArchivedPagePagination.sortBy +
        "&order_by=" +
        this.getArchivedPagePagination.sortType
    )
    .then((res) => {
      if (res) {
        this.archiveMatches = organizeRecords(res.result_no_match_matches);
        this.totalArchiveMatches = res.total_records;
      }
    });
  this.isArchiveLoading = false;
},
async getArchiveIncidentsUngrouped() {
  this.isArchiveLoading = true;
  await fetchWrapper
    .get(
      "v2/get-no-match-matches-ungrouped?page=" +
        this.getArchivedPagePagination.page +
        "&limit=" +
        this.getArchivedPagePagination.rowsPerPage +
        "&search=" +
        this.getArchivedPagePagination.search +
        "&sort_by=" +
        this.getArchivedPagePagination.sortBy +
        "&order_by=" +
        this.getArchivedPagePagination.sortType
    )
    .then((res) => {
      if (res) {
        this.archiveMatchesUngrouped = organizeRecordsUngrouped(res.result_no_match_matches);
        this.totalArchiveMatches = res.total_records;
      }
    });
  this.isArchiveLoading = false;
},
    async getMatch(id) {
      this.isLoading = true;
      await fetchWrapper.post("v2/get-match", { id: id }).then((res) => {
        if (res) {
          const metadata = res.match_record.metadata ? JSON.parse(res.match_record.metadata.replace(/'/g, '"')) : {};
          // Extracting only "User ID"
          const userId = metadata['User ID'];
          const source_type = metadata.source_type || "";
          console.log(userId);
          this.item = {
            ...res.match_record,
            source_type: source_type,
            metadata: userId ? { 'User ID': userId } : {}, // Only keep "User ID" if exists
          };
          console.log(this.item , "get-match");
        }
      });
      this.isLoading = false;
    },
    async getMatchesInGroup(groupId, matchStatus) {
      this.isMatchesInGroupLoading = true;
      await fetchWrapper
      .get(
        "v2/get-matches-in-group?group_id=" +
          groupId +
          "&match_status=" +
          matchStatus +
          "&page=" +
          this.getMatchesInGroupPagePagination.page +
          "&limit=" +
          this.getMatchesInGroupPagePagination.rowsPerPage +
          "&search=" +
          this.getMatchesInGroupPagePagination.search +
          "&sort_by=" +
          this.getMatchesInGroupPagePagination.sortBy +
          "&order_by=" +
          this.getMatchesInGroupPagePagination.sortType
      )
      .then((res) => {
        if (res) {
          this.matchesInGroupItems = res.match_records;
          this.totalMatchesInGroup = res.total_records;
        }
      });
      this.isMatchesInGroupLoading = false;
    },
    async updateNotStatus(ids) {
      this.isLoading = true;
      await fetchWrapper.post("update-notification-status", { ids: ids }).then((res) => {
        if(res){
        this.getNotifications();
        }
      });
      this.isLoading = false;
    },
    async updateUnreadStatus(ids) {
      this.isLoading = true;
      await fetchWrapper.post("update-unread-notification-status", { ids: ids }).then((res) => {
        if(res){
        this.getNotifications();
        }
      });
      this.isLoading = false;
    },
    async getContactInfo(unique_id) {
      this.isLoading = true;
      await fetchWrapper.post("matches-get-contact-info", { unique_id: unique_id }).then((res) => {
        if(res){
        this.contactInfo = res.match_contact_message;
        }
      });
      this.isLoading = false;
    },
    async getNotifications() {
      await fetchWrapper.get("get-notifications").then((res) => {
        if(res){
        this.notifications = res.notification_count;
        }
      });
    },
    async getJurisdiction(countries) {
      let url = "v2/get-jurisdiction"; 
      if (Array.isArray(countries) && countries.length > 0) {
        const query = countries
          .map((c) => `country=${encodeURIComponent(c)}`)
          .join("&");
        url += `?${query}`;
      }

      await fetchWrapper.get(url).then((res) => {
        if (res) {
          this.jurisdiction = res.data;
        }
      });
    },
    async getApplicationStatus() {
      await fetchWrapper.get("get-application-status").then((res) => {
          if (res.status){
              this.applicationStatus = true
              this.appStatusCause = res.app_status_cause
          }
          else if (this.applicationStatus && !res.status){
            const authStore = useAuthStore();
            this.applicationStatus = false;
            $('.modal').modal('hide');
            authStore.logout();
          }
        })
        .catch(error => {
            console.error('Error fetching application status:', error);
        });
    },
    async getLeagues() {
      const response = await fetchWrapper.get("get-leagues");
      if(response){
      const responseData = response.data;
      responseData.sort((a, b) => a.display_name.localeCompare(b.display_name));
      // Create a new array excluding the first element
      const responseDataWithoutFirst = responseData.filter((element) => element.id !== 100);
      this.leagues = responseDataWithoutFirst.map(element => ({
        id: element.id,
        level: element.level,
        parent_id: element.parent_id,
        value: element.display_name,
        name: element.name,
        display: element.display_name
      }));
    }
    },
    async updateMatchStatus(id, match_status, match_status_notes) {
      await fetchWrapper.post("update-match-status", {
        id: parseInt(id),
        match_status: match_status,
        match_status_notes: match_status_notes,
      });
    },
    async updateMatchStatusSilence(id, silent_mode) {
      await fetchWrapper.post("match/update-status-silenced", {
        id: parseInt(id),
        "silent_mode": silent_mode,
      });
    },

    async updatePassword(password, confirm_password) {
      await fetchWrapper.post("update-user-password", {
        password: password,
        confirm_password: confirm_password
      });
    },
    async updateCSVCheck() {
      await fetchWrapper.post("update-csv-acceptance", {
        csv_acceptance: true,
      });
      const authStore = useAuthStore();
      authStore.csvAccept = 1
      localStorage.setItem("csvAccept", 1);
    }
  },
});

const organizeRecords = (records) => {
  const result = [];
  const recordMap = [];
  records.forEach(record => {
    record.showChildren = false;
    const { group_id, ...rest } = record;
    if (typeof group_id !== 'undefined') {
      if (result.some(record => record.group_id === group_id)) {
        recordMap.push({ group_id, ...rest }); // Add record to recordMap
      } else {
        result.push({ group_id, ...rest, childrens: [] }); // Add showChildren property
      }
    }
  });
  result.forEach(parent => {
    if (typeof parent.group_id !== 'undefined') {
      parent.childrens = recordMap.filter(record => record.group_id === parent.group_id);
      parent.childrens.sort((a, b) => new Date(b.when_match) - new Date(a.when_match)); // Sort childrens array in descending order based on when_match
    }
  });
  console.log(result, "organize result");
  return result;
}

const organizeRecordsUngrouped = (records) => {
  return records.map(({ match, group_total_records }) => ({
    ...match,
    group_total_records,
  }));
};